import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import creditlogo from "../Assets/navLogo.svg";
import * as Routers from "./Routers";
import OurRoutes from "./Routes";

function AppRouter() {
  return (
    <Router>
      <Suspense
      // fallback={
      //   <div className="flex flex-col justify-center items-center w-full h-screen">
      //     <img
      //       src={creditlogo}
      //       alt="Logo"
      //       className="mb-3 "
      //       style={{ width: "100px" }}
      //     />
      //     <p></p>
      //   </div>
      // }
      >
        <Routes>
          <Route path={OurRoutes.MainPage} element={<Routers.MainPage />}>
            <Route index element={<Routers.HomePage />} />

            <Route path={OurRoutes.ABOUT_US} element={<Routers.ABOUT_US />} />

            <Route path={OurRoutes.PRODUCTS} element={<Routers.PRODUCTS />} />

            <Route path={OurRoutes.BLOG} element={<Routers.BLOG />} />

            <Route
              path={OurRoutes.CONTACT_US}
              element={<Routers.CONTACT_US />}
            />
            <Route
              path={OurRoutes.PRIVACY_POLICY}
              element={<Routers.PRIVACY_POLICY />}
            />
            <Route
              path={OurRoutes.REFUND_POLICY}
              element={<Routers.REFUND_POLICY />}
            />
            <Route
              path={OurRoutes.TERM_CONDITION}
              element={<Routers.TERM_CONDITION />}
            />
            <Route path={OurRoutes.SUPPORT} element={<Routers.SUPPORT />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default AppRouter;
